/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

/**
 *     Import
 *     - CSS
 */
import './styles/HeaderContainer.css'

/**
 * [render description]
 * @param  {String}      className [Class to be applied on the main header block]
 * @param  {Bool}        fullwidth [True = Block will fit 100% of the browser width]
 * @param  {String}      title     [Main title]
 * @param  {String}      image     [Image for the title]
 * @param  {String}      pretitle  [Text on top of main title]
 * @return {ReactNode}   children  [All code on the right side should be passed as children]
 */
export default class HeaderContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            typeSelected: this.props.selected ? this.props.selected : this.props.titles[0],
            selectorOpened: false,
        }
    }

    changeType = (element) => {
        if (element !== this.state.typeSelected) {
            this.setState({ typeSelected: element, selectorOpened: false })
            this.props.triggerAction(element)
        }
    }

    openSelector = () => {
        this.setState({ selectorOpened: true })
    }

    render() {
        return (
            <div className={`header${(this.props.fullwidth) ? ' header--full' : ''} ${this.props.className || ''}`}>
                <div className="header_inner">

                    <div className="header__title">
                        {(this.props.back) ? (
                            <div
                                className="header__title__back"
                                onClick={this.props.backAction}
                            >
                                <DropdownArrowIcon color={'#5174AE'} /><span>BACK</span>
                            </div>
                        ) : null}
                        {this.props.pretitle && <h3>{this.props.pretitle}</h3>}
                        <div>
                            {
                                (this.props.image) ?
                                    <div className="header__title__image">
                                        <img src={this.props.image} alt="Profile photo" />
                                    </div>
                                    :
                                    null
                            }
                            <h2
                                onClick={this.openSelector}
                                className={`${(this.props.titles.length > 1) ? 'pointer' : ''}
                                ${(this.props.image) ? ' imageText' : ''}`}
                            >
                                {this.state.typeSelected.charAt(0).toUpperCase() + this.state.typeSelected.slice(1)}
                                {(this.props.titles.length > 1) ?
                                    <div className="arrow">
                                        <DropdownArrowIcon />
                                    </div> :
                                    null
                                }

                            </h2>
                            {(this.props.titles.length > 1) ? (
                                <div
                                    className={`header__title__dropdown ${(!this.state.selectorOpened) ?
                                        'hidden' :
                                        ''}`
                                    }
                                >
                                    {
                                        this.props.titles.map((element, index) => (
                                            <div
                                                key={index}
                                                className={(this.state.typeSelected === element) ? 'selected' : ''}
                                                onClick={() => { this.changeType(element) }}
                                            >
                                                {element.charAt(0).toUpperCase() + element.slice(1)}
                                            </div>
                                        ))
                                    }
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="header__content">
                        {this.props.children}
                    </div>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/HeaderContainer/HeaderContainer.tsx